import { Trans, useTranslation } from "react-i18next";

import {
  HistoryEntryCard,
  type EntityHistoryEntry,
} from "@/components/ui/v2/history";

export function SegmentArchivedHistoryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  const { t } = useTranslation();
  const actor = t("history.actor.system");
  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <Trans
          i18nKey="history.line1.segmentArchived"
          values={{ actor }}
          components={{ b: <strong className="font-semibold" /> }}
        />
      }
    />
  );
}
